import React from "react";
import "./LiveAdsCard.css";

const LiveAdsCard = (props) => {
  const { data, key } = props;
  return (
    <div className="liveAdsCard" key={key}>
      <div className="liveAdsHeader">
        <img className="liveAdsUserImage" src="/assets/images/profilepic.png" alt="userImage" />
        <div className="liveAdsUserInfo">
          <p className="liveAdsHeading">Mukund Cake Shop</p>
          <p className="liveAdsSubHeading">
            Sponsored
            <img className="liveAdsSponsorImg" src="/assets/icons/sponsor.svg" alt="sponsor-img" />
          </p>
        </div>
      </div>
      <p className="liveAdsContent">{data.adCaption}</p>
      <img className="liveAdsImg1" src={data.adImage} alt="liveAds-img1" />
      <div className="liveAdsCard-contactus">
        <span className="liveAdsCard-contactus-info">
          <h6 className="s3c-cu-info-heading">Pre-Pay and Save</h6>
          <p className="s3c-cu-info-subHeading">Get extra 2000off on orders above</p>
        </span>
        <a href="" className="liveAds-contactus-link">
          Contact us
        </a>
      </div>
      {data.adPreviewLink && (
        <div className="liveAds-facebookLink">
          <img className="liveAds-fbLink-img" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/facebook.svg" alt="live-ads-fb-link" />
          <a href={data.adPreviewLink} className="liveAds-fbLink-text">
            View this ad on Facebook
          </a>
        </div>
      )}
    </div>
  );
};

export default LiveAdsCard;
